import React from "react";

const useModal = () => {
  let [modal, setModal] = React.useState(false);
  let [modalContent, setModalContent] = React.useState(false);
  let [isDragAndDrop, setDragAndDrop] = React.useState(false);

  let handleModal = (
    content = false,
    isCloseAction,
    dragAndDrop,
  ) => {

    setDragAndDrop(dragAndDrop);

    if (!isCloseAction) {
      setModal(!modal);
    } else {
      setModal(false);
    }

    if (content) {
      setModalContent(content);
    }
  };

  return { modal, handleModal, modalContent, isDragAndDrop };
};

export default useModal;
